import { useState, useCallback } from 'react';

export default function useAlerta() {
  const [alerta, setAlerta] = useState({ tipo: 'success', mensagem: '', visivel: false });

  const mostrarAlerta = useCallback((mensagem, tipo = 'success') => {
    setAlerta({ tipo, mensagem, visivel: true });
  }, []);

  const fecharAlerta = useCallback(() => {
    setAlerta((prev) => ({ ...prev, visivel: false }));
  }, []);

  return { alerta, mostrarAlerta, fecharAlerta };
}
